import { Amplify, Auth } from "aws-amplify";

// aws-exports.js
export const awsConfig = {
    Auth: {
        region: process.env.REACT_APP_REGION|| 'us-east-1',
        userPoolId: process.env.REACT_APP_ADMIN_COGNITO_USERPOOL_ID,
        userPoolWebClientId: process.env.REACT_APP_ADMIN_COGNITO_CLIENT_ID,
        identityPoolId: process.env.REACT_APP_ADMIN_COGNITO_IDENTITY_POOL_ID,
        authenticationFlowType: 'USER_PASSWORD_AUTH'
    },
    Storage: {
        AWSS3: {
            bucket: process.env.REACT_APP_BUCKET_NAME,
            region: process.env.REACT_APP_REGION|| 'us-east-1',
        }
    }
};
  
async function authenticateUser(username,password) {
    Amplify.configure(awsConfig)
    try {         
    // Authenticate user using username/email and password
        const loginResponse = await Auth.signIn(username, password);
    } catch (error) {
        console.error('Authentication Error:', error);
    }
}

export default authenticateUser;